const SUB_BUILDING_TYPES = {
  fr: [
    {
      label: 'Appartement',
      value: 'apartment',
    },
    {
      label: 'Bureau',
      value: 'office',
    },
    {
      label: 'Aucun',
      value: 'none',
    },
  ],
  en: [
    {
      label: 'Apartment',
      value: 'apartment',
    },
    {
      label: 'Office',
      value: 'office',
    },
    {
      label: 'None',
      value: 'none',
    },
  ],

};

export default SUB_BUILDING_TYPES;
